interface TagsColorScheme {
  backgroundColor: string;
  color: string;
}

export const tagsColorScheme: TagsColorScheme[] = [
  {
    backgroundColor: '#CEEAF9',
    color: '#164B68',
  },
  {
    backgroundColor: '#FFEBC2',
    color: '#734D00',
  },
  {
    backgroundColor: '#F4ECFF',
    color: '#3F1B73',
  },
];
